import { useEffect, useState } from 'react';
import { useIsTablet } from './use-device-context';

const STORAGE_KEY = 'kg_desktop_shell';

function readFlag(): boolean {
  if (typeof window === 'undefined') return false;
  const v = window.localStorage.getItem(STORAGE_KEY);
  if (v === '0' || v === 'false') return false;
  return true;
}

/**
 * True when the new desktop/tablet shell (sidebar + top bar) should render
 * on viewports >= 768px. Disable locally with:
 *   localStorage.setItem('kg_desktop_shell', '0')
 */
export function useDesktopShell(): boolean {
  const isAtLeastTablet = useIsTablet();
  const [enabled, setEnabled] = useState<boolean>(readFlag);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setEnabled(readFlag());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return enabled && isAtLeastTablet;
}
